function isIOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let is_IOS = false;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    is_IOS = true;
  }

  return is_IOS;
}

export default isIOS;
